/**
 * Painel placeholder para abas ainda não implementadas (PR1 · Foundation).
 *
 * Distingue dois casos honestos:
 *   - 'soon'            → tem backend; será habilitada em fatia futura.
 *   - 'deferred-backend' → sem campo no modelo (Gatilhos/Verificação); honest-defer.
 */

import type { PlaybookTabDef } from '../tab-definitions';

export function TabPlaceholder({ tab }: { tab: PlaybookTabDef }): JSX.Element {
  const deferred = tab.state === 'deferred-backend';
  return (
    <div className="pb-panel" role="tabpanel" aria-label={tab.label}>
      <h2 className="pb-panel__title">{tab.label}</h2>
      <p className="pb-panel__subtitle">
        {deferred
          ? 'Esta configuração ficará disponível quando o backend expuser o campo correspondente. Por ora não há fonte de dados para exibir.'
          : 'Esta aba será habilitada em uma próxima fatia desta tela.'}
      </p>
    </div>
  );
}
